import { render, staticRenderFns } from "./NewComing.vue?vue&type=template&id=5731f29a&scoped=true&"
import script from "./NewComing.vue?vue&type=script&lang=js&"
export * from "./NewComing.vue?vue&type=script&lang=js&"
import style0 from "./NewComing.vue?vue&type=style&index=0&id=5731f29a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5731f29a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
